import { useState, useEffect } from 'react'
import { Bell, X } from 'lucide-react'
import { requestFcmPermission } from '@/lib/fcm'
import { isDevMode } from '@/lib/firebase'

export function PushPermissionBanner() {
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isDevMode()) return
    if (!('Notification' in window)) return
    if (Notification.permission === 'default') setVisible(true)
  }, [])

  if (!visible) return null

  const enable = async () => {
    setLoading(true)
    await requestFcmPermission()
    setLoading(false)
    setVisible(false)
  }

  return (
    <div className="mx-4 mt-3 mb-1 flex items-center gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
      <Bell className="w-4 h-4 text-amber-600 flex-shrink-0" />
      <p className="text-[12px] text-amber-800 flex-1 leading-snug">
        Recevez les alertes prix et mises à jour de vos cultures
      </p>
      <button
        onClick={enable}
        disabled={loading}
        className="text-[12px] font-bold text-amber-700 hover:text-amber-900 transition flex-shrink-0 disabled:opacity-50"
      >
        {loading ? '…' : 'Activer'}
      </button>
      <button
        onClick={() => setVisible(false)}
        className="flex-shrink-0 text-amber-400 hover:text-amber-600 transition"
        aria-label="Fermer"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  )
}
